/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState, useEffect, useRef } from "react";
import {
  uploadFileLogo,
  getAllLogo,
  deleteLogo,
  updateLogo,
  addNewLogo,
  getLogoById,
} from "../services/userServices";
import homeImage from "../assets/image/main_image.png";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";
import "../assets/css/Homepage.css";
import { useNavigate } from "react-router-dom";

const ManageLogo = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showHide, setShowHide] = useState(false);
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState(null);
  const tabbarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (tabbarRef.current && !tabbarRef.current.contains(event.target)) {
        setShowHide(false);
      }
    }

    if (showHide) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showHide]);

  useEffect(() => {
    fetchLogo();
  }, []);

  const fetchLogo = async () => {
    try {
      const response = await getAllLogo();
      setItems(response.respObj);
    } catch (err) {
      setError("Failed to load logo");
    } finally {
      setLoading(false);
    }
  };
  const [form, setForm] = useState({
    image: "",
    status: "Active",
  });
  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      const formData = new FormData();
      formData.append("file", file);

      try {
        const result = await uploadFileLogo(formData);
        if (result.response) {
          setForm((prev) => ({
            ...prev,
            image: result.response.respObj,
          }));
        }
      } catch (error) {
        console.error("Upload failed:", error);
      }
    }
  };
  const handleEditLogo = async (id) => {
    const response = await getLogoById(id);
    const imageUrl = response.respObj.image;

    setForm({
      id: response.respObj.id,
      image: imageUrl,
      status: response.respObj.status || "Active",
    });

    setPreviewImage(imageUrl);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setForm({ image: "", status: "Active" });
  };

  const handleSubmit = async () => {
    if (!form.image) {
      Swal.fire({
        title: "Warning!",
        text: "Please enter complete information!",
        icon: "warning",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      await updateLogo(form);

      fetchLogo();
      setShowModal(false);
      Swal.fire({
        title: "Success!",
        text: form.id ? "Updated successfully!" : "Added successfully!",
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong!",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const openTabbar = () => {
    setShowHide(!showHide);
  };
  const handleNavigation = (path) => {
    navigate(path);
  };
  return (
    <>
      <div ref={tabbarRef} className={`tabbar ${showHide ? "open" : ""}`}>
        <ul>
          <li>
            <svg
              style={{ cursor: "pointer" }}
              onClick={openTabbar}
              fill="#000000"
              width="24px"
              height="24px"
              viewBox="0 -2 28 28"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path d="m5.216 11.998c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m5.216 2.608c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m5.216 21.389c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m9.794 0h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
                <path d="m9.794 9.39h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
                <path d="m9.794 18.781h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              </g>
            </svg>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/home")}
            >
              Home
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/manage-license")}
            >
              License
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/manage-logo")}
            >
              Manage logo
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/change-password")}
            >
              Change password
            </div>
          </li>
        </ul>
      </div>
      <div
        style={{
          backgroundImage: `url(${homeImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          minHeight: "300px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          //   alignItems: "center",
          //   justifyContent: "center",
          textAlign: "center",
          color: "black",
          fontSize: "2rem",
          fontWeight: "bold",
          textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
          position: "relative",
        }}
      >
        <div className="top-action">
          <svg
            onClick={openTabbar}
            fill="#000000"
            width="24px"
            height="24px"
            viewBox="0 -2 28 28"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="m2.61 0h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              <path d="m2.61 9.39h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              <path d="m2.61 18.781h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
            </g>
          </svg>
          <div
            style={{
              // position: "absolute",
              right: "10px",
              top: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onClick={logout}
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9 0L3 2V14H1V16H15V14H13V2H11V14H9V0ZM6.75 9C7.16421 9 7.5 8.55229 7.5 8C7.5 7.44772 7.16421 7 6.75 7C6.33579 7 6 7.44772 6 8C6 8.55229 6.33579 9 6.75 9Z"
                  fill="#000000"
                ></path>{" "}
              </g>
            </svg>
            Logout
          </div>
        </div>
        Manage Logo
      </div>

      <div className="container mt-4">
        {loading && <p>Loading...</p>}
        {error && <div className="alert alert-danger">{error}</div>}

        <div className="row justify-content-center">
          {items.map((item, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className="card h-100">
                <img
                  src={`https://dcu.dev.api.jeyunvn.com${item.image}`}
                  className="card-img-top"
                  alt="Logo"
                  style={{
                    height: "200px",
                    objectFit: "contain",
                    padding: "1rem",
                  }}
                />
                <div className="card-body">
                  <h5 className="card-title">Status</h5>
                  <p className="card-text text-success font-weight-bold">
                    {item.status === "Active"
                      ? item.status
                      : "Not activated yet"}
                  </p>
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={() => handleEditLogo(item.id)}
                  >
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                      <g
                        id="SVGRepo_tracerCarrier"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></g>
                      <g id="SVGRepo_iconCarrier">
                        {" "}
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M21.1213 2.70705C19.9497 1.53548 18.0503 1.53547 16.8787 2.70705L15.1989 4.38685L7.29289 12.2928C7.16473 12.421 7.07382 12.5816 7.02986 12.7574L6.02986 16.7574C5.94466 17.0982 6.04451 17.4587 6.29289 17.707C6.54127 17.9554 6.90176 18.0553 7.24254 17.9701L11.2425 16.9701C11.4184 16.9261 11.5789 16.8352 11.7071 16.707L19.5556 8.85857L21.2929 7.12126C22.4645 5.94969 22.4645 4.05019 21.2929 2.87862L21.1213 2.70705ZM18.2929 4.12126C18.6834 3.73074 19.3166 3.73074 19.7071 4.12126L19.8787 4.29283C20.2692 4.68336 20.2692 5.31653 19.8787 5.70705L18.8622 6.72357L17.3068 5.10738L18.2929 4.12126ZM15.8923 6.52185L17.4477 8.13804L10.4888 15.097L8.37437 15.6256L8.90296 13.5112L15.8923 6.52185ZM4 7.99994C4 7.44766 4.44772 6.99994 5 6.99994H10C10.5523 6.99994 11 6.55223 11 5.99994C11 5.44766 10.5523 4.99994 10 4.99994H5C3.34315 4.99994 2 6.34309 2 7.99994V18.9999C2 20.6568 3.34315 21.9999 5 21.9999H16C17.6569 21.9999 19 20.6568 19 18.9999V13.9999C19 13.4477 18.5523 12.9999 18 12.9999C17.4477 12.9999 17 13.4477 17 13.9999V18.9999C17 19.5522 16.5523 19.9999 16 19.9999H5C4.44772 19.9999 4 19.5522 4 18.9999V7.99994Z"
                          fill="#ffffff"
                        ></path>{" "}
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show"
          style={{ background: "rgba(0, 0, 0, 0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h6>Edit Logo</h6>
                <button
                  className="btn-close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Upload Image</label>
                  <input
                    type="file"
                    className="form-control"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                  <img
                    src={`https://dcu.dev.api.jeyunvn.com${form.image}`}
                    alt="Preview"
                    className="mt-2"
                    style={{ width: "100px", height: "auto" }}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Status</label>

                  <input
                    type="text"
                    className="form-control"
                    value="Active"
                    disabled
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-success" onClick={handleSubmit}>
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageLogo;
